import React, { useState, useEffect } from "react";
import axios from "../helper/axios";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const ListSection = ({ title, items, showAll, handleClick, selectedItem }) => {
  const renderedItems = showAll ? items : items.slice(0, 3);

  return (
    <div className="col-sm-4 col-6 mb-4">
      <h6 className="pb-lg-2 pb-sm-3">
        <b>{title}</b>
      </h6>
      <ul className="p-0 m-0 shop-list-group">
        {renderedItems.map((item, index) => (
          <li
            className={`list-group-item ${
              selectedItem === item ? "font-weight-bold" : ""
            }`}
            key={index}
          >
            <span onClick={() => handleClick(item, false)}>{item}</span>{" "}
            {/* Pass 'false' as the second parameter */}
          </li>
        ))}
      </ul>
      <a
        className="text-link mt-3 view-all"
        onClick={() => handleClick(null, true)}
      >
        {showAll ? "Show Less" : "View All"}
      </a>
    </div>
  );
};

const WeddingRing = () => {
  const [showAllProductSettingItems, setShowAllProductSettingItems] =
    useState(false);
  const [showAllMetalItems, setShowAllMetalItems] = useState(false);
  const [showAllStyleItems, setShowAllStyleItems] = useState(false);

  // const [getShape, setShape] = useState([]);
  // const [getProductType, setProductType] = useState([]);
  const [getMetal, setMetal] = useState([]);
  const [getProductSetting, setProductSetting] = useState([]);
  const [getStyle, setStyle] = useState([]);

  const [allMetalResponse, setAllMetalResponse] = useState([]);

  const defaultMetalValue = "white gold";
  const defaultSettingValue = "classic prong";
  const defaultStyleValue = "Solitaire";

  const [selectedMetalItems, setSelectedMetalItems] = useState([
    defaultMetalValue,
  ]);
  const [selectedProductSetting, setSelectedProductSetting] = useState([
    defaultSettingValue,
  ]);
  const [selectedStyles, setSelectedStyles] = useState([defaultStyleValue]);
  const [viewAllClicked, setViewAllClicked] = useState(true);

  const [allProducts, getAllProducts] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const productsToMap =
    filteredData && filteredData.length > 0 ? filteredData : allProducts;

  const [priceSliderRange, setPriceSliderRange] = useState(20, 50);

  useEffect(() => {
    fetchJeweleryData();
  }, []);

  const fetchJeweleryData = async () => {
    try {
      const category = {
        category: ["jewelry"],
        collection: ["wedding"],
        isAll: 1,
      };
      const response = await axios.post("/product_read", category);
      const allProducts = response.data.data;
      getAllProducts(allProducts);

      // console.log('̥allProducts', allProducts);

      const metalData = await axios.get("/metal_read");
      const metalProduct = metalData.data.data;
      setAllMetalResponse(metalProduct);

      const metalArray = Object.values(metalProduct).map(
        (metal) => metal.metal_name
      );
      setMetal(metalArray.slice(0, -1));

      const productSettingsData = await axios.get("/product_settings_read");
      const productSettingsProduct = productSettingsData.data.data;
      const productSettingsArray = Object.values(productSettingsProduct).map(
        (productsettings) => productsettings.product_settings_name
      );
      setProductSetting(productSettingsArray.slice(0, -1));

      const StyleData = await axios.get("/style_read");
      const StyleProduct = StyleData.data.data;
      const styleArray = Object.values(StyleProduct).map(
        (styleProduct) => styleProduct.style_name
      );
      console.log("styleArray", styleArray);
      for (let i = 0; i <= styleArray.length; i++) {
        if (styleArray[i] === "empty") {
          //remove empty from styleArray if it is empty
          let newStyleArray = [...styleArray];
          delete newStyleArray[newStyleArray.indexOf("empty")];
        } else {
          setStyle(styleArray.slice(0, -1));
        }
      }
    } catch (error) {
      console.error(error.response);
      console.log("alert̥: Failed to fetch products.");
    }
  };

  const handleClickProductSetting = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllProductSettingItems(!showAllProductSettingItems);
      setSelectedProductSetting(item ? [item] : []);
    } else {
      // Handle individual item click here
      setSelectedProductSetting((prevSelected) => {
        if (prevSelected.includes(item)) {
          // If the item is already selected, deselect it
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          // If the item is not selected, select it and clear other selected items
          // setSelectedMetalItems([]);
          // setSelectedStyles([]);
          return [item];
        }
      });
    }
  };

  const handleClickMetal = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllMetalItems(!showAllMetalItems);
      setSelectedMetalItems(item ? [item] : []);
    } else {
      // Handle individual item click here
      setSelectedMetalItems((prevSelected) => {
        if (prevSelected.includes(item)) {
          // If the item is already selected, deselect it
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          // If the item is not selected, select it and clear other selected items
          // setSelectedProductSetting([]);
          // setSelectedStyles([]);
          return [item];
        }
      });
    }
  };

  const handleClickStyle = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllStyleItems(!showAllStyleItems);
      setSelectedStyles(item ? [item] : []);
    } else {
      // Handle individual item click here
      setSelectedStyles((prevSelected) => {
        if (prevSelected.includes(item)) {
          // If the item is already selected, deselect it
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          // If the item is not selected, select it and clear other selected items
          // setSelectedProductSetting([]);
          // setSelectedMetalItems([]);
          return [item];
        }
      });
    }
  };

  const handleViewAllClick = async () => {
    if (
      selectedMetalItems.length > 0 ||
      selectedProductSetting.length > 0 ||
      selectedStyles.length > 0
    ) {
      const filteredProductData = {
        category: ["jewelry"],
        collection: ["wedding"],
        metal: selectedMetalItems,
        settings: selectedProductSetting,
        product_style: selectedStyles,
        isAll: 1,
      };

      try {
        // Send data back to the API with the appended URL
        const response = await axios.post("/product_read", filteredProductData);

        const newData = response.data.data; // Assuming the API response contains the data array
        setFilteredData(newData);
        console.log("̥response", response);
        setViewAllClicked(true);
      } catch (error) {
        console.error("Error sending data:", error);
        alert("No data Found!!");
      }
    }
  };

  const navigate = useNavigate();

  const handleProductClick = async (product) => {
    // Construct the JSON payload with the product ID
    const payload = {
      product_sku: product.product_sku,
    };

    try {
      // Perform the POST request to get the single product details
      const response = await axios.post("/product_read", payload);

      // Assuming the API response contains the data for the single product
      const singleProductData = response.data.data;
      // console.log('̥singleProductData', singleProductData[0]);

      // Navigate to the single product page programmatically using navigate function
      navigate(
        `/singleproduct/${singleProductData[0].product_sku}`
        // `/singleproduct/${singleProductData[0].product_name.trim().replace(/\s+/g, '-')}-${singleProductData[0].product_sku}`
      );
    } catch (error) {
      console.error("Error fetching single product:", error);
    }
  };

  const metalElements = allMetalResponse.map((metalItem, index) => (
    <option key={index} value={metalItem.metal_id}>
      {metalItem.metal_name}
    </option>
  ));

  const priceData = allProducts.map((metalItem) => metalItem.product_price);

  // Get the minimum value from the array
  const minPrice = Math.min(...priceData);

  // Get the maximum value from the array
  const maxPrice = Math.max(...priceData);

  const handlePriceSliderChange = (value) => {
    setPriceSliderRange(value);
  };

  console.log("filteredData", filteredData);

  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="page-banner hero-container mb-0">
              <div className="banner-content">
                <h1>Wedding Rings</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row pt-5">
            <div className="col-md-6">
              <div className="row">
                <div className="col-12">
                  <h4 className="pb-4">
                    <b>Pre-Designed Wedding Rings</b>
                  </h4>
                </div>
              </div>
              <div className="row">
                <ListSection
                  title="Shop by Metal"
                  items={getMetal}
                  showAll={showAllMetalItems}
                  handleClick={handleClickMetal}
                  selectedItem={selectedMetalItems[0]}
                />

                <ListSection
                  title="Shop by Settings"
                  items={getProductSetting}
                  showAll={showAllProductSettingItems}
                  handleClick={handleClickProductSetting}
                  selectedItem={selectedProductSetting[0]}
                />

                <ListSection
                  title="Shop by Style"
                  items={getStyle}
                  showAll={showAllStyleItems}
                  handleClick={handleClickStyle}
                  selectedItem={selectedStyles[0]}
                />
              </div>

              <div className="row">
                {/* <a href="#" className='btn mt-4 d-inline-block btn__primary w-auto'>View More</a> */}
                <button
                  onClick={handleViewAllClick}
                  disabled={selectedMetalItems.length === 0}
                  className="btn btn__outline"
                >
                  View All
                </button>
              </div>
            </div>
            <div className="col-md-6 ps-sm-5 pt-lg-0 pt-md-5">
              <div className="design-own-ring text-center">
                <h4 className="pb-5 text-center">
                  <b>Design Your Wedding Rings</b>
                </h4>
                {/* <img src={require("../assets/ring-making.png")} className='w-100' alt="" /> */}
                <div>
                  <ul className="progressbar">
                    <li className="active">Select Your Diamond</li>
                    <li>Select Setting</li>
                    <li>Buy a Ring</li>
                  </ul>
                </div>

                <a
                  href="/allproducts"
                  className="link-style mb-4 mt-4 mx-auto d-inline-block w-auto"
                >
                  Coming Soon.....
                </a>
              </div>
            </div>
          </div>

          <div className="row text-center mt-5 pt-5">
            <div className="col-12">
              <h3>
                <b>Check Our All Pre-Designed Wedding Rings</b>
              </h3>

              {/* <div>{productsToMap.map((product, index) => (<h5 className='mt-3 card-title'>{product.product_name}</h5> ))}</div> */}

              <div className="row mt-5">
                {productsToMap.map((product, index) => (
                  // <NavLink to={product_url_new} className="col-sm-3 mb-4 card">
                  <NavLink
                    onClick={() => handleProductClick(product)}
                    className="col-sm-3 mb-4 card"
                    key={index}
                  >
                    <div className="product-card card-body">
                      <div className="p-0">
                        <img
                          src={product.product_image[0]}
                          className="w-100"
                          alt=""
                        />
                        <h5 className="mt-3 card-title">
                          {product.product_name}
                        </h5>
                        <span className="d-block">
                          Price: ${product.product_price}
                        </span>
                      </div>
                    </div>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <h3 className="text-center">
                <b>Unveiling Timeless Glamour</b>
              </h3>
            </div>
            <div className="col-sm-6 mb-0">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-4.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Silver Moon</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mb-0">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-1.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Divine Heritage</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-2.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Colorful Gems</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-3.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Celestial Beauty</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WeddingRing;
